(function ($) {

    'use strict';
  
    function Global() {

        this.settings = {

            set_offset_with_fixed_body: {

                padding: [

                    '.header__content--sticky',

                    '.header--transparent',

                    '.fixed-sidebar',

                    '.footbar',

                    '#admin_bar_iframe',

                    '#preview-bar-iframe'

                ],

                margin: [

                    '.footer--fixed'

                ]

            }

        };
        this.dom = {

            $icons: $('#theme-icons')

        };



        window.$window = $(window);

        window.$document = $(document);

        window.$html = $(html);

        window.$body = $html.find('body');



        jQuery.cookie = () => { };



        theme.AssetsLoader.onPageLoaded(function () {

            $('.js-slider-tracking').one('init', function () {

                window.dispatchEvent(new CustomEvent('slider-initialized', {

                    detail: {

                        slider: $(this)[0]

                    }

                }));

            });

        });

    };



    Global.prototype = $.extend({}, Global.prototype, {

        load: function () {

            // $document.on('shopify:section:load', function () {

            //     theme.LazyImage.update();

            //     if(theme.StickySidebar && theme.StickySidebar.reload) {

            //         theme.StickySidebar.reload();

            //     }



            //     if(theme.Masonry) {

            //         theme.Masonry.init(true);

            //     }



            //     if(theme.Tooltip) {

            //         theme.Tooltip.init();

            //     }



            //     if(theme.RangeOfPrice) {

            //         theme.RangeOfPrice.init();

            //     }

            // });



            // $document.on('shopify:section:unload', function () {

            //     if(theme.Masonry) {

            //         theme.Masonry.destroy();

            //     }



            //     if(theme.Tooltip) {

            //         theme.Tooltip.destroy();

            //     }



            //     if(theme.RangeOfPrice) {

            //         theme.RangeOfPrice.destroy();

            //     }

            // });

        },

        bodyHasScroll: function (prop) {

            var d = document,

                e = d.documentElement,

                b = d.body,

                client = "client" + prop,

                scroll = "scroll" + prop;



            return /CSS/.test(d.compatMode) ? (e[client] < e[scroll]) : (b[client] < b[scroll]);

        },

        fixBody: function () {

            if (this.bodyHasScroll('Height')) {

                $body.addClass('offset-scrollHOLD offset-scroll-padding fixed-elem');



                for (var i = 0; i < this.settings.set_offset_with_fixed_body.padding.length; i++) {

                    $(this.settings.set_offset_with_fixed_body.padding[i]).addClass('offset-scroll-padding fixed-elem');

                }



                for (var i = 0; i < this.settings.set_offset_with_fixed_body.margin.length; i++) {

                    $(this.settings.set_offset_with_fixed_body.margin[i]).addClass('offset-scroll-margin fixed-elem');

                }

            }



            this._fixed_scroll_top = pageYOffset;



            $body.css({ top: pageYOffset * -1 });

            $body.addClass('overflow-hiddenHOLD position-fixed left-0 w-100');

            // $body.addClass('body-no-scroll');

        },

        unfixBody: function () {

            // $body.removeClass('offset-scrollHOLD offset-scroll-padding fixed-elem');
            // $body.removeClass('body-no-scroll');


            $body.removeClass('offset-scrollHOLD overflow-hiddenHOLD offset-scroll-padding fixed-elem position-fixed left-0 w-100');



            $body.add($html).scrollTop(this._fixed_scroll_top);

            this._fixed_scroll_top = null;



            $body.css({ top: '' });



            for (var i = 0; i < this.settings.set_offset_with_fixed_body.padding.length; i++) {

                $(this.settings.set_offset_with_fixed_body.padding[i]).removeClass('offset-scroll-padding fixed-elem');

            }



            for (var i = 0; i < this.settings.set_offset_with_fixed_body.margin.length; i++) {

                $(this.settings.set_offset_with_fixed_body.margin[i]).removeClass('offset-scroll-margin fixed-elem');

            }

        },
        responsiveHandler: function (obj) {

            var namespace = obj.namespace ? obj.namespace : '.widthHandler',

                current_bp,

                is_mobile_prop = obj.is_mobile_prop || 'is_mobile',

                is_desktop_prop = obj.is_desktop_prop || 'is_desktop';



            function bind() {

                $.each(obj.events, function (event, func) {

                    $.each(event.split(' '), function (i, v) {

                        if (obj.delegate) {

                            $(obj.element).on(v + namespace, obj.delegate, func);

                        } else {

                            $(obj.element).on(v + namespace, func);

                        }

                    });



                    if (obj.onbindload) {

                        func();

                    }

                });



                obj.was_added_events = true;

            };



            function unbind() {

                $.each(obj.events, function (event) {

                    $.each(event.split(' '), function (i, v) {

                        $(obj.element).unbind(v + namespace);

                    });

                });



                if (obj.was_added_events && obj.onunbind_func) {

                    obj.onunbind_func();

                }



                obj.was_first_load = false;

            };



            function on_resize() {

                if (theme.current[is_mobile_prop] !== current_bp) {

                    current_bp = theme.current[is_mobile_prop];



                    if ((obj.on_desktop && theme.current[is_desktop_prop]) || (obj.on_mobile && theme.current[is_mobile_prop])) {

                        bind();



                        setTimeout(function () {

                            if (obj.onbindtrigger) {

                                if (!obj.was_first_load) {

                                    $.each(obj.events, function () {

                                        $(obj.element).trigger(obj.onbindtrigger);

                                    });



                                    obj.was_first_load = true;

                                }

                            }

                        }, 0);

                    } else {

                        unbind();

                    }

                }

            };



            $window.on('theme.resize.responsiveHandler' + namespace, function () {

                on_resize();

            });



            on_resize();



            return {

                unbind: function () {

                    $window.unbind('theme.resize.responsiveHandler' + namespace);

                    unbind();

                }

            };

        },

        getIcon: function (numb, html) {

            var $icon = this.dom.$icons.find('.icon-theme-' + numb);



            return html ? $icon.parent().html() : $icon.clone();

        }

    });



    theme.AssetsLoader.onPageLoaded(function () {

        theme.Global = new Global;

    });

    window.slate = window.slate || {};

    slate.rte = {
        wrapIframe: function (options) {
            var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

            options.$iframes.each(function () {
                $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

                this.src = this.src;
            });
        }
    };

    theme.AssetsLoader.onPageLoaded(function () {
        // var tableSelectors = '.rte table';

        // slate.rte.wrapTable({
        //     $tables: $(tableSelectors),
        //     tableWrapperClass: 'rte__table-wrapper'
        // });

        var iframeSelectors =
            '.rte iframe[src*="youtube.com/embed"]:not(.not-responsive),' +
            '.rte iframe[src*="player.vimeo"]:not(.not-responsive)';

        slate.rte.wrapIframe({
            $iframes: $(iframeSelectors),
            iframeWrapperClass: 'rte__video-wrapper'
        });
    });

    window.theme = window.theme || {};

    function Position() {

        this.settings = {

            name: 'data-js-position-name',

            desktop: 'data-js-position-desktop',

            mobile: 'data-js-position-mobile',

            all: 'data-js-position-all'

        };



        this.selectors = {

            elements: '.js-position'

        };



        this.load();

    };



    Position.prototype = $.extend({}, Position.prototype, {

        load: function () {

            var _ = this,

                current_position_is_desktop;



            function check_position() {

                if (current_position_is_desktop !== theme.current.is_desktop) {

                    _.update();



                    current_position_is_desktop = theme.current.is_desktop;

                }

            };



            $window.on('theme.resize.position', function () {

                check_position();

            });



            check_position();



            var $elements_append_onload = $(this.selectors.elements).filter('[data-js-position-onload]');



            this.append($elements_append_onload, this.settings.all);

        },

        update: function (name) {

            var $elements = name ? $('[' + this.settings.name + '="' + name + '"]') : $(this.selectors.elements).not('[data-js-position-onload]'),

                append_to = theme.current.is_desktop ? this.settings.desktop : this.settings.mobile;



            this.append($elements, append_to);

        },

        append: function ($elements, append_to) {

            var _ = this;



            $elements.each(function () {

                var $this = $(this),

                    append_to_name = $this.attr(_.settings.name);



                var $append_to = $('[' + append_to + '="' + append_to_name + '"]');



                if ($append_to.length && !$.contains($append_to[0], $this[0])) {

                    if ($append_to.find('[' + _.settings.name + '="' + append_to_name + '"]').length) {

                        $this.remove();

                    } else {

                        $this.appendTo($append_to);

                    }

                }

            });

        }

    });



    theme.AssetsLoader.onPageLoaded(function () {

        theme.Position = new Position;

    });
    class Cookie {
        constructor() {
            jQuery.cookie = (name, value, options) => {
                return value ? this.set(name, value, options) : this.get(name);
            };
        }

        get(name) {
            let matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
            ));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }

        set(name, value, options = {}) {
            options = {
                path: '/',
                ...options
            };

            if (options.expires instanceof Date) {
                options.expires = options.expires.toUTCString();
            }

            let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

            for (let optionKey in options) {
                updatedCookie += "; " + optionKey;
                let optionValue = options[optionKey];
                if (optionValue !== true) {
                    updatedCookie += "=" + optionValue;
                }
            }

            document.cookie = updatedCookie;
        }

        deleteCookie(name) {
            set(name, "", {
                'max-age': -1
            });
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        theme.Cookie = new Cookie;
    });
    class Countdown extends HTMLElement {
        constructor() {
            super();

            setTimeout(() => {
                this.displayType = this.classList.contains('countdown--type-02') ? 2 : 1;
                this.startDate = new Date(this.getUTCTimeStr(this.dataset.startDate));
                this.endDate = new Date(this.getUTCTimeStr(this.dataset.endDate));

                this.display();
                this.inrerval = setInterval(() => this.display(), 1000);
            }, 0);
        }

        // 将北京时间字符串转成UTC时间
        getUTCTimeStr(dateString) {
            // 将北京时间字符串转换成UTC时间
            var utcMilliseconds = Date.parse(dateString + ' UTC') - 28800000;
            // 将UTC时间的毫秒数转换成表示UTC时间的日期对象
            var utcDate = new Date(utcMilliseconds);
            // 输出结果
            return utcDate.toISOString(); // "2023-06-02T07:00:00.000Z"
        }

        display() {
            const now = new Date();
            if (now >= this.startDate && now <= this.endDate) {
                this.parentNode.classList.remove('d-none-important');
                this.render(this.getRemainingTime());
                return;
            }
            if (now > this.endDate) {
                this.parentNode.classList.add('d-none-important');
                this.inrerval && clearInterval(this.inrerval);
            }
        }

        getTotal() {
            return Date.parse(this.endDate) - Date.parse(new Date());
        }

        getRemainingTime() {
            const total = this.getTotal();
            const seconds = Math.floor((total / 1000) % 60);
            const minutes = Math.floor((total / 1000 / 60) % 60);
            const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
            const days = Math.floor(total / (1000 * 60 * 60 * 24));

            return {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            };
        }

        render(time) {
            let html = '';
            html += this.buildSectionHTML(time.days, 'Days', true,);
            html += this.buildSectionHTML(time.hours, 'Hours', true);
            html += this.buildSectionHTML(time.minutes, 'Mins', true);
            html += this.buildSectionHTML(time.seconds, 'Secs', true);
            this.innerHTML = html;
        }

        buildSectionHTML(time, postfix, showZero) {
            let timeToString = time.toString();

            if (this.displayType === 1) {
                if (!time && showZero) timeToString = '0';

                return `<span class="countdown__section">
                      <span class="countdown__time">${timeToString}</span>
                      <span class="countdown__postfix">${postfix}</span>
                      </span>`;

            } else if (this.displayType === 2) {
                if (timeToString.length < 2) timeToString = `0${time}`;

                let html = '<span class="countdown__section"><span class="countdown__time">';

                for (var i = 0; i < timeToString.length; i++) {
                    html += `<span>${timeToString.charAt(i)}</span>`;
                }

                html += `</span>
                      <span class="countdown__postfix">${postfix}</span>
                      </span>`;

                return html;
            }
        }

        disconnectedCallback() {
            if (this.inrerval) clearInterval(this.inrerval);
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('countdown-element', Countdown);
    });
    function dynamicCheckout() {
        this.selectors = {
            template_dynamic_checkout: '.template-dynamic-checkout',
            dynamic_checkout: '.js-dynamic-checkout'
        };
    };

    dynamicCheckout.prototype = $.extend({}, dynamicCheckout.prototype, {
        load: function (parent) {
            const _ = this,
                $parent = parent ? $(parent) : $(document),
                $dynamic_checkout_button = $parent.find(this.selectors.dynamic_checkout);

            $body.on('change', '[data-js-dynamic-checkout-confirmation]', function () {
                _.dynamicCheckoutUpdate($(this));
            });

            if ($dynamic_checkout_button.length) {
                if (Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
                return;
            }

            const $template_dynamic_checkout = $parent.find(this.selectors.template_dynamic_checkout);

            if ($template_dynamic_checkout.length) {
                $template_dynamic_checkout.replaceWith($($template_dynamic_checkout[0].content).find('[data-js-product-button-dynamic-checkout]'));
                $template_dynamic_checkout.remove();
            }

            $('[data-js-dynamic-checkout-confirmation]').each(function () {
                _.dynamicCheckoutUpdate($(this));
            });

            const $dynamic_checkout = $(this.selectors.dynamic_checkout);

            if (!$dynamic_checkout.length) {
                return;
            }

            this.checkCheckoutLoad($dynamic_checkout);

            $window.on('scroll.checkCheckoutLoad', function () {
                _.checkCheckoutLoad($dynamic_checkout);
            });
        },
        dynamicCheckoutUpdate: function ($btn) {
            $btn.parents(this.selectors.dynamic_checkout).find('[data-js-dynamic-checkout-button-wrapper]')[$btn.is(':checked') ? 'removeClass' : 'addClass']('disabled');
        },
        checkCheckoutLoad: function ($dynamic_checkout) {
            if ($dynamic_checkout[0].getBoundingClientRect().top < window.innerHeight + 300) {
                $window.unbind('scroll.checkCheckoutLoad');
                if (Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            }
        }
    });

    theme.AssetsLoader.onPageLoaded(function () {
        theme.dynamicCheckout = new dynamicCheckout;
    });
    class Preloader {
        constructor() {
            this.$preloader = $('#theme-loader .js-preloader');
        }

        set($elem, obj = {}) {
            $elem = $($elem);

            if ($elem.length && !$elem.find('> .js-preloader').length) {
                var $clone = this.$preloader.clone(),
                    $spinner = $clone.find('[data-js-preloader-spinner]'),
                    $image = $spinner.find('img'),
                    fixed_offset_l;

                if (obj.bg === false) {
                    $clone.find('[data-js-preloader-bg]').remove();
                }
                if (obj.spinner === false) {
                    $spinner.remove();
                }
                if (obj.fixed === true) {
                    $spinner.addClass('fixed');

                    fixed_offset_l = ($elem.innerWidth() / 2 + $elem[0].getBoundingClientRect().left) * 100 / theme.current.width;

                    $spinner.css({
                        left: fixed_offset_l + '%'
                    });
                }
                if (obj.delay) {
                    $elem.addClass('preloading-element--delay');
                }
                if (obj.blur) {
                    $elem.addClass('preloading-element preloading-element--blur');
                    $spinner.remove();
                } else {
                    $elem.addClass('preloading-element');

                    $elem[0].preloadTimeout = $image.one('load', () => {
                        $elem.addClass('preloading-element--process');
                    });

                    $image.attr('src', $image.attr('data-src'));
                }

                $elem.append($clone);

                if (obj.blur) {
                    $elem[0].preloadTimeout = setTimeout(() => {
                        $elem.addClass('preloading-element--process');
                    }, 10);
                }
            }
        }

        unset($elem) {
            $elem = $($elem);

            if (!$elem.length) return;

            if ($elem[0].preloadInterval) {
                clearTimeout($elem[0].preloadTimeout);
                $elem[0].preloadInterval = null;
            }

            $elem.find('> .preloader').remove();
            $elem.removeClass('preloading-element preloading-element--blur preloading-element--process preloading-element--delay');
        }
    };

    theme.AssetsLoader.onPageLoaded(function () {
        theme.Preloader = new Preloader;
    });
    function Popups() {
        this.selectors = {
            popup: '.js-popup',
            button: '.js-popup-button',
            button_close: '[data-js-popup-close]',
            bg: '[data-js-popup-bg]'
        };
        this.load();
    };

    Popups.prototype = $.extend({}, Popups.prototype, {
        load: function () {
            var $popup = $(this.selectors.popup);

            if ($popup.length) {
                var _ = this;

                $body.on('click', '[data-js-popup-button="message"]', function () {
                    var $product = $(this).parents('[data-js-product]'),
                        json = $product.attr('data-json-product'),
                        current_id = +$product.attr('data-product-variant-id');

                    if (json) {
                        json = JSON.parse(json);

                        $.each(json.variants, function () {
                            if (this.id === current_id) {
                                $('#ContactFormProductUrl').attr('value', theme.domain + '/products/' + json.handle + '?variant=' + current_id);
                                $('#ContactFormProductSKU').attr('value', this.sku ? this.sku : 'Empty');

                                return false;
                            }
                        });
                    }
                });

                $body.on('click', this.selectors.button, function (e) {
                    var $this = $(this),
                        name = $this.attr('data-js-popup-button');

                    if (_.callByName(name, $this)) {
                        e.preventDefault();
                        _.toggleOverlayStuff(false);
                        return false;
                    }
                });

                $popup.on('click', this.selectors.button_close, function (e) {
                    var $this = $(this),
                        name = $this.parents('[data-js-popup-name]').attr('data-js-popup-name');

                    _.closeByName(name, $this);
                    e.preventDefault();
                    _.toggleOverlayStuff(true);
                    return false;
                });

                $popup.on('click', '[data-js-popup-name]:not([data-disable-bg-click])', function (e) {
                    var $t = $(e.target);

                    if ($t[0].hasAttribute('data-js-popup-name')) {
                        var name = $t.attr('data-js-popup-name');

                        _.closeByName(name, $t);
                        _.toggleOverlayStuff(true);
                    }
                });

                setTimeout(function () {
                    $popup.find('[data-js-auto-call="true"]').each(function () {
                        _.callByName($(this).attr('data-js-popup-name'));
                    });
                }, 0);
            }
        },
        loadDynamicContent: function (name, $target) {
            if (!$target) {
                return;
            }

            const id = $target.attr('data-js-popup-dynamic-id');

            if (!id) {
                return;
            }

            const $insert = this.getByName(name).find('[data-js-popup-dynamic-insert]');

            $insert.html($(`[data-js-popup-dynamic-content="${id}"]`).html());
        },
        getByName: function (name) {
            var $popup = $(this.selectors.popup),
                $content = $popup.find('[data-js-popup-name="' + name + '"]');

            return $content;
        },
        callByName: function (name, $target) {
            var _ = this,
                $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                is_ajax = $content.attr('data-js-popup-ajax') !== undefined ? true : false;

            function onCall() {
                $popup.scrollTop(0);
                $body.addClass('popup-opened');

                $bg.one('transitionend', function () {
                    $content.add($bg).removeClass('animate');

                    $content.trigger(name + '.' + 'call.after', [$content, $target ? $target : null]);
                });

                $content.add($bg).addClass('animate');

                setTimeout(function () {
                    $content.add($bg).addClass('visible');

                    if ($bg.css('transition-duration') === '0s') {
                        $bg.trigger('transitionend');
                    }
                    // collection页预览product页面显示affirm插件
                    const affirmEl = $content.find('#affirm-as-low-as');
                    if (affirmEl.length) {
                        window.affirm && window.affirm.ui.ready(function () {
                            window.affirm.ui.refresh();
                        });
                    }
                }, 0);

                if ($content[0].hasAttribute('data-js-popup-mobile-only')) {
                    $window.on('theme.changed.breakpoint.popups', function () {
                        if (!theme.current.is_mobile) {
                            _.closeByName(name);
                        }
                    });
                }
            };

            if ($content.length) {
                if (theme.current.is_desktop && $content[0].hasAttribute('data-js-popup-mobile-only')) {
                    return false;
                }
                if (theme.tooltips_enable && $target) {
                    $('.tippy-popper').addClass('d-none-important');
                }

                $bg.unbind('transitionend');

                $content.trigger(name + '.' + 'call.before', [$content, $target ? $target : null]);

                this.loadDynamicContent(name, $target);

                $popup.addClass('active');

                $popup.find('[data-js-popup-name]').removeClass('show visible');
                $popup.add($content).addClass('show');

                theme.Global.fixBody();

                if (is_ajax) {
                    $content.addClass('is-process-loading');

                    theme.Preloader.set($popup, {
                        fixed: true,
                        delay: true
                    });

                    $content.on('contentloaded', function () {
                        $content.removeClass('is-process-loading');

                        onCall();

                        theme.Preloader.unset($popup);
                    });
                } else {
                    onCall();
                }

                $body.on('keyup.popups', function (e) {
                    if (e.keyCode === 27 && !$body.hasClass('product-gallery-fullscreen')) {
                        _.closeAll();
                    }
                });

                $popup.attr('tabindex', 10).focus();

                $content.trigger(name + '.' + 'call.visible', [$content, $target ? $target : null]);

                return true;
            } else {
                return false;
            }
        },
        closeByName: function (name, $target, callback) {
            var $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                duration = $bg.css('transition-duration');

            if ($content.length) {
                $body.removeClass('popup-opened');
                $content.unbind('contentloaded').removeClass('is-process-loading');
                $bg.unbind('transitionend');
                $body.unbind('keyup.popups');
                $window.unbind('theme.changed.breakpoint.popups');

                $content.trigger(name + '.' + 'close.before', [$content, $target ? $target : null]);

                theme.Preloader.unset($popup);

                $bg.one('transitionend', function () {
                    $popup.add($content).removeClass('show');
                    $content.add($bg).removeClass('animate');

                    theme.Global.unfixBody();

                    $popup.removeClass('active');

                    if (callback) {
                        callback();
                    }

                    $popup.attr('tabindex', 0);

                    $content.trigger(name + '.' + 'close.after', [$content, $target ? $target : null]);
                });

                $content.add($bg).addClass('animate');

                if (!$bg.hasClass('visible') || $bg.css('transition-duration') === '0s') {
                    $bg.trigger('transitionend');
                }

                $content.add($bg).removeClass('visible');

                if (theme.tooltips_enable && $target) {
                    $('.tippy-popper').removeClass('d-none-important');
                }

                return true;
            } else {
                if (callback) {
                    callback();
                }

                return false;
            }
        },
        closeAll: function () {
            var _ = this,
                $popup = $(this.selectors.popup + '.active'),
                $content = $popup.find('[data-js-popup-name]').filter('.show, .is-process-loading');

            if ($content.length) {
                $content.each(function () {
                    _.closeByName($content.attr('data-js-popup-name'));
                });

                return true;
            } else {
                return false;
            }
        },
        addHandler: function (name, event, func, handler) {
            handler = handler || 'on';

            $body[handler](name + '.' + event, '[data-js-popup-name="' + name + '"]', function (e, $popup, $target) {
                func($popup, $target);
            });
        },
        removeHandler: function (name, event) {
            $body.unbind(name + '.' + event);
        },
        toggleOverlayStuff: function (open) {
            // console.log('关闭遮盖')
            $('iframe[title="启动消息传送窗口的按钮"]')[open ? 'show' : 'hide']();
        }
    });

    theme.AssetsLoader.onPageLoaded(function () {
        theme.Popups = new Popups;
    });

    // 心愿单功能
    function StoreListsEngine(namespace, callback) {
        this.namespace = namespace;

        this.selectors = {
            button: '.js-store-lists-add-' + namespace,
            button_remove: '.js-store-lists-remove-' + namespace,
            button_clear: '.js-store-lists-clear-' + namespace,
            has_items: '[data-js-store-lists-has-items-' + namespace + ']',
            dhas_items: '[data-js-store-lists-dhas-items-' + namespace + ']'
        };
        // 现在不需要区分登录还是未登录，所以先注释
        // if (theme.customer) {
        //     this.current_storage = namespace + '-customer-' + theme.customer_id;

        //     this.app_obj = {
        //         namespace: namespace,
        //         customerid: theme.customer_id,
        //         shop: theme.permanent_domain,
        //         domain: theme.host,
        //         iid: theme.lists_app.iid
        //     };
        // } else {
        //     this.current_storage = namespace + '-guest';
        // }

        this.current_storage = namespace + '-guest';

        this.load(callback);
    };

    StoreListsEngine.prototype = $.extend({}, StoreListsEngine.prototype, {
        load: function (callback) {
            var _ = this;

            // 现在不需要区分登录还是未登录，所以先注释
            // if (theme.customer) {
            //     var customer_storage = localStorage.getItem(this.current_storage),
            //         customer_storage_arr = customer_storage ? JSON.parse(customer_storage) : [],
            //         guest_storage = localStorage.getItem(this.namespace + '-guest'),
            //         guest_storage_arr = guest_storage ? JSON.parse(guest_storage) : [],
            //         sort_data_arr = [],
            //         sort_data_arr_json,
            //         sort_customer_storage_arr,
            //         sort_concat_arr,
            //         sort_concat_arr_json;

            //     var sortObjectsArray = function (arr) {
            //         var obj = {},
            //             new_arr = [],
            //             i = 0;

            //         for (i = 0; i < arr.length; i++) {
            //             $.each(arr[i], function (k, v) {
            //                 obj[k + ''] = v;
            //             });
            //         }

            //         $.each(obj, function (k, v) {
            //             var obj = {};

            //             obj[k] = v;
            //             new_arr.push(obj);
            //         });

            //         return new_arr;
            //     };

            //     var loadData = function () {
            //         _.getCustomerList(function (data) {
            //             if (data.status !== 200) {
            //                 return;
            //             }

            //             sort_customer_storage_arr = sortObjectsArray(customer_storage_arr);

            //             if (data.items && data.items.length) {
            //                 sort_data_arr = sortObjectsArray(data.items);
            //             }

            //             sort_concat_arr = sortObjectsArray(sort_customer_storage_arr.concat(sort_data_arr));

            //             sort_concat_arr_json = JSON.stringify(sort_concat_arr);
            //             sort_data_arr_json = JSON.stringify(sort_data_arr);

            //             if (sort_concat_arr_json !== JSON.stringify(sort_customer_storage_arr)) {
            //                 localStorage.setItem(_.current_storage, sort_concat_arr_json);
            //                 _.setCustomerList(sort_concat_arr_json);
            //             } else if (sort_concat_arr_json !== sort_data_arr_json) {
            //                 localStorage.setItem(_.current_storage, sort_data_arr_json);
            //                 _.setCustomerList(sort_data_arr_json);
            //             }

            //             _.updateHeaderCount();
            //             _.checkProductStatus();

            //             localStorage.removeItem(_.namespace + '-guest');
            //         });
            //     };

            //     if (guest_storage_arr.length) {
            //         callback({
            //             trigger: function (is_active) {
            //                 if (is_active) {
            //                     customer_storage_arr = customer_storage_arr.concat(guest_storage_arr);
            //                 }

            //                 loadData();
            //             },
            //             info: {
            //                 namespace: _.namespace,
            //                 count: guest_storage_arr.length
            //             }
            //         });
            //     } else {
            //         loadData();
            //     }
            // } else {
            //     this.updateHeaderCount();
            //     this.checkProductStatus();
            // }

            this.updateHeaderCount();
            this.checkProductStatus();

            $body.on('click', this.selectors.button, function (e) {
                var $this = $(this);

                $this.attr('disabled', 'disabled');

                var $product = $this.parents('[data-js-product]'),
                    handle = $product.attr('data-product-handle'),
                    id = +$product.attr('data-product-variant-id');

                if ($this.attr('data-button-status') === 'added') {
                    _.removeItem(id, handle, function (data) {
                        $this.removeAttr('data-button-status');
                        $this.removeAttr('disabled');
                        // 上报到神策
                        if (_.current_storage == 'wishlist-guest') {
                            document.dispatchEvent(new CustomEvent('theme:wishlist:removed', {
                                detail: { handle, id }
                            }));
                        }
                    });
                } else {
                    _.addItem(id, handle, function (data) {
                        $this.attr('data-button-status', 'added');
                        $this.removeAttr('disabled');
                        // 上报到神策
                        if (_.current_storage == 'wishlist-guest') {
                            document.dispatchEvent(new CustomEvent('theme:wishlist:added', {
                                detail: { handle, id }
                            }));
                        }
                    });
                }

                e.preventDefault();
                return false;
            });

            function removeCallback($product, handle, id) {
                var find = '[data-js-store-lists-product-' + _.namespace + ']',
                    $popup = theme.Popups.getByName(_.namespace);

                if (handle) find += '[data-product-handle="' + handle + '"]';
                if (id) find += '[data-product-variant-id="' + id + '"]';

                $(find).each(function () {
                    var $this = $(this);

                    $($this.parent('[class*="col"]').length ? $this.parent() : $this).remove();
                });

                if ($product && typeof $product !== undefined && $product.length) $product.remove();

                if (!$popup.hasClass('d-none-important')) {
                    theme.StoreLists.popups[_.namespace].update($popup);
                }

                // 上报到神策
                if (_.current_storage == 'wishlist-guest') {
                    if (handle && id) {
                        document.dispatchEvent(new CustomEvent('theme:wishlist:removed', {
                            detail: { handle, id }
                        }));
                    }
                }
            };

            $body.on('click', this.selectors.button_remove, function () {
                var $this = $(this),
                    $product = $this.parents('[data-js-product]'),
                    handle = $product.attr('data-product-handle'),
                    id = +$product.attr('data-product-variant-id');

                _.removeItem(id, handle, function () {
                    removeCallback($product, handle, id);
                });
            });

            $body.on('click', this.selectors.button_clear, function () {
                _.clear(function () {
                    removeCallback();
                });
            });
        },
        setCustomerList: function (items, callback) {
            // if (theme.customer) {
            //     $.ajax({
            //         type: "POST",
            //         url: "https://" + theme.lists_app.url + "/api/massadd",
            //         data: $.extend({}, this.app_obj, {
            //             purge: 'yes',
            //             items: items
            //         }),
            //         cache: false,
            //         success: function (data) {
            //             if (callback) callback(data);
            //         }
            //     });
            // }
        },
        getCustomerList: function (callback) {
            // if (theme.customer) {
            //     $.ajax({
            //         type: 'POST',
            //         url: 'https://' + theme.lists_app.url + '/api/getlist',
            //         data: this.app_obj,
            //         cache: false,
            //         success: function (data) {
            //             if (callback) callback(data);
            //         }
            //     });
            // }
        },
        addCustomerItem: function (id, handle, callback) {
            // if (theme.customer) {
            //     $.ajax({
            //         type: 'POST',
            //         url: 'https://' + theme.lists_app.url + '/api/add',
            //         data: $.extend({}, this.app_obj, {
            //             key: id,
            //             value: handle
            //         }),
            //         cache: false,
            //         success: function (data) {
            //             if (callback) callback(data);
            //         }
            //     });
            // }
        },
        removeCustomerItem: function (id, callback) {
            // if (theme.customer) {
            //     $.ajax({
            //         type: 'POST',
            //         url: 'https://' + theme.lists_app.url + '/api/delete',
            //         data: $.extend({}, this.app_obj, {
            //             key: id,
            //             _method: 'DELETE'
            //         }),
            //         cache: false,
            //         success: function (data) {
            //             if (callback) callback(data);
            //         }
            //     });
            // }
        },
        clearCustomerItem: function (callback) {
            // if (theme.customer) {
            //     $.ajax({
            //         type: 'POST',
            //         url: 'https://' + theme.lists_app.url + '/api/massdelete',
            //         data: $.extend({}, this.app_obj, {
            //             _method: 'DELETE'
            //         }),
            //         cache: false,
            //         success: function (data) {
            //             if (callback) callback(data);
            //         }
            //     });
            // }
        },
        addItem: function (id, handle, callback) {
            var storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [],
                obj = {};

            obj[id] = handle;

            items.push(obj);

            localStorage.setItem(this.current_storage, JSON.stringify(items));

            this.checkProductStatus();
            this.updateHeaderCount();

            this.addCustomerItem(id, handle);

            if (callback) callback();
        },
        removeItem: function (id, handle, callback) {
            var storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [];

            $.each(items, function (i) {
                if (id && this[id] && this[id] === handle) {
                    items.splice(i, 1);
                    return false;
                } else if (!id && this[Object.keys(this)[0]] === handle) {
                    items.splice(i, 1);
                    return false;
                }
            });

            localStorage.setItem(this.current_storage, JSON.stringify(items));

            this.checkProductStatus();

            $(this.selectors.has_items)[items.length > 0 ? 'removeClass' : 'addClass']('d-none-important');
            $(this.selectors.dhas_items)[items.length > 0 ? 'addClass' : 'removeClass']('d-none-important');

            this.updateHeaderCount();

            this.removeCustomerItem(id);

            if (callback) callback();
        },
        clear: function (callback) {
            localStorage.removeItem(this.current_storage);

            this.checkProductStatus();

            $(this.selectors.has_items).addClass('d-none-important');
            $(this.selectors.dhas_items).removeClass('d-none-important');

            this.updateHeaderCount();

            this.clearCustomerItem();

            if (callback) callback();
        },
        checkProductStatus: function (products) {
            const $products = products ? $(products) : $('[data-js-product]');

            var _ = this,
                storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [],
                $active_products = $();

            $.each(items, function () {
                $.each(this, function (k, v) {
                    var $selected_product = $products.filter('[data-product-handle="' + v + '"][data-product-variant-id="' + k + '"]');

                    if ($selected_product.length) {
                        $active_products = $active_products.add($selected_product);
                    }
                });
            });

            $products.not($active_products).find(_.selectors.button).removeAttr('data-button-status');
            $active_products.find(_.selectors.button).attr('data-button-status', 'added');
        },
        updateHeaderCount: function (callback) {
            var storage = localStorage.getItem(this.current_storage),
                count = storage ? JSON.parse(storage).length : 0;

            $('[data-js-' + this.namespace + '-count]').attr('data-js-' + this.namespace + '-count', count).html(count);
            if (callback) callback();
        }
    });

    function StoreListsEnginePopup(namespace) {
        this.namespace = namespace;

        this.load();
    };

    StoreListsEnginePopup.prototype = $.extend({}, StoreListsEnginePopup.prototype, {
        load: function () {
            var _ = this;

            // 心愿单弹框
            theme.Popups.addHandler(this.namespace, 'call.visible', function ($popup) {
                _.update($popup, function () {
                    $popup.trigger('contentloaded');
                });
            });

            // 全部心愿单弹框
            theme.Popups.addHandler(this.namespace + '-full', 'call.visible', function ($popup) {
                _.updateFull($popup, function () {
                    $popup.trigger('contentloaded');
                });
            });
        },
        _resultToHTML: function ($items, data, callback) {
            var $template = $($('#template-' + this.namespace + '-ajax')[0].content),
                $fragment = $(document.createDocumentFragment());

            for (var i = 0; i < data.params.length; i++) {
                $.each(data.params[i], function (k, v) {
                    var product = null,
                        variant = null;

                    $.each(data.products, function () {
                        if (this.handle === v) {
                            product = this;
                        }
                    });

                    if (!product) {
                        return;
                    }

                    $.each(product.variants, function () {
                        if (+this.id === +k) {
                            variant = this;
                            return false;
                        }
                    });

                    if (!variant) {
                        variant = product.variants[0];
                    }

                    var image = variant.featured_image ? variant.featured_image.src : product.featured_image;

                    var $item = $template.clone(),
                        $product = $item.find('.product-store-lists'),
                        $image = $item.find('.product-store-lists__image img'),
                        $title = $item.find('.product-store-lists__title a'),
                        $variant = $item.find('.product-store-lists__variant'),
                        $price = $item.find('.product-store-lists__price .price'),
                        $links = $item.find('a').not('.product-store-lists__remove');

                    $product.attr('data-product-variant-id', k);
                    $product.attr('data-product-handle', v);
                    $links.attr('href', '/products/' + v + '?variant=' + k);
                    $title.html(product.title);
                    $image.attr('srcset', Shopify.resizeImage(image, '120x') + ' 1x, ' + Shopify.resizeImage(image, '240x') + ' 2x');

                    if (variant.title !== 'Default Title') {
                        $variant.html(variant.title).removeClass('d-none-important');
                    }

                    theme.ProductPrice.insert($price, variant.price, variant.compare_at_price);

                    $fragment.append($item);
                });
            }

            $items.html('');
            $items.append($fragment);

            if (callback) {
                callback();
            }
        },
        _getProducts: function (items, callback) {
            var _ = this,
                handles = [],
                cycles = 1,
                data_items = [],
                i = 0;

            if (this.xhr) {
                this.xhr.abort();
            }

            for (; i < items.length; i++) {
                $.each(items[i], function () {
                    handles.push(this);
                });
            }

            i = 0;
            cycles = Math.max(1, Math.ceil(handles.length / 20));

            function recurcionRequests(i) {
                var request_handles = handles.slice(i * 20, (i + 1) * 20);

                _.xhr = $.ajax({
                    type: 'GET',
                    url: '/collections/all',
                    cache: false,
                    data: {
                        view: 'products_by_handle',
                        constraint: request_handles.join('+')
                    },
                    dataType: 'html',
                    success: function (data) {
                        $.each(JSON.parse(data), function () {
                            data_items.push(this);
                        });

                        i++;

                        if (i < cycles) {
                            recurcionRequests(i);
                        } else {
                            callback({
                                params: items,
                                products: data_items
                            });
                        }
                    }
                });
            };

            recurcionRequests(i);
        },
        update: function ($popup, callback) {
            var _ = this,
                storage = localStorage.getItem(theme.StoreLists.lists[this.namespace].current_storage),
                items = storage ? JSON.parse(storage) : [],
                $content = $popup.find('.popup-' + this.namespace + '__content'),
                $empty = $popup.find('.popup-' + this.namespace + '__empty'),
                $items = $popup.find('.popup-' + this.namespace + '__items'),
                $count = $popup.find('[data-js-popup-' + this.namespace + '-count]');
            $count.html(items.length);
            //$count.html(theme.strings.general.popups[this.namespace].count.replace('{{ count }}', items.length));
            $content[items.length > 0 ? 'removeClass' : 'addClass']('d-none-important');
            $empty[items.length > 0 ? 'addClass' : 'removeClass']('d-none-important');

            if (items.length > 0) {
                var data = this._getProducts(items, function (data) {
                    _._resultToHTML($items, data, callback);

                    if (theme.MultiCurrency) {
                        theme.MultiCurrency.update();
                    }
                });
            } else {
                $items.html('');

                if (callback) {
                    callback();
                }
            }
        },
        updateFull: function ($popup, callback) {
            var _ = this,
                $content = $popup.find('.popup-' + this.namespace + '-full__content');

            $content.html('');

            var obj = {
                type: 'GET',
                data: {
                    view: _.namespace
                },
                cache: false,
                success: function (data) {
                    $content.html(data);
                    theme.LazyImage.update();
                    if (theme.MultiCurrency) {
                        theme.MultiCurrency.update();
                    }

                    if (callback) {
                        callback();
                    }
                }
            };

            // 由于现在不区分登录还是未登录，所以注释
            // if (theme.customer) {
            //     $.extend(obj, {
            //         url: '/cart'
            //     });
            // } else {
            //     var storage = localStorage.getItem(theme.StoreLists.lists[this.namespace].current_storage),
            //         items = storage ? JSON.parse(storage) : [],
            //         constraint = [];

            //     for (var i = 0; i < items.length; i++) {
            //         $.each(items[i], function (v, k) {
            //             constraint.push(k + '=' + v);
            //         });
            //     }

            //     constraint.join('+');

            //     $.extend(true, obj, {
            //         url: '/collections/all',
            //         data: {
            //             constraint: constraint
            //         }
            //     });
            // }

            var storage = localStorage.getItem(theme.StoreLists.lists[this.namespace].current_storage),
                items = storage ? JSON.parse(storage) : [],
                constraint = [];

            for (var i = 0; i < items.length; i++) {
                $.each(items[i], function (v, k) {
                    constraint.push(k + '=' + v);
                });
            }

            constraint.join('+');

            $.extend(true, obj, {
                url: '/collections/all',
                data: {
                    constraint: constraint
                }
            });

            // 不管登录还是未登录都要走这个请求
            $.ajax(obj);
        }
    });


    function StoreLists() {
        this.namespaces = [
            'wishlist',
            'compare'
        ];

        this.load();
    };

    StoreLists.prototype = $.extend({}, StoreLists.prototype, {
        lists: {},
        popups: {},
        load: function () {
            var triggers_array = [];

            for (var i = 0; i < this.namespaces.length; i++) {
                this.lists[this.namespaces[i]] = new StoreListsEngine(this.namespaces[i], function (obj) {
                    triggers_array.push(obj);
                });
                this.popups[this.namespaces[i]] = new StoreListsEnginePopup(this.namespaces[i]);
            }

            if (triggers_array.length) {
                for (var i = 0; i < triggers_array.length; i++) {
                    triggers_array[i].trigger(true);
                }
            }
        },
        checkProductStatus: function () {
            $.each(this.lists, function () {
                this.checkProductStatus();
            });
        },
        updateHeaderCount: function () {
            $.each(this.lists, function () {
                this.updateHeaderCount();
            });
        }
    });

    theme.AssetsLoader.onPageLoaded(function () {
        theme.StoreLists = new StoreLists;
    });
    function ProductOptions() {
        this.selectors = {
            options: '.js-product-options',
            options_attr: '[data-js-product-options]'
        };

        this.afterChange = [];

        this.load();
    };

    ProductOptions.prototype = $.extend({}, ProductOptions.prototype, {
        load: function () {
            var _ = this,
                timeout,
                xhr;
            
            function initVariantPayment() {
                if (!window.ptABTestRegisters) {
                    window.ptABTestRegisters = [];
                }
                window.PTPaymentsOverTime = true;
                handlePaymentsOverTime()
            }

            function handlePaymentsOverTime() {
                document.dispatchEvent(new CustomEvent('theme:variant:update:installinfo'));
            }
        
            initVariantPayment();

            function onProcess(e, that) {
                var $this = that || $(this),
                    $options = $this.parents(_.selectors.options),
                    $section = $this.parents('[data-property]'); // data-property： 变体类型标志

                if ($this.hasClass('disabled') || ($this.hasClass('active') && !$section[0].hasAttribute('data-disable-auto-select'))) {
                    return;
                }

                var $values = $section.find('[data-js-option-value]'),
                    $product = $this.parents('[data-js-product]'),
                    json = $product.attr('data-json-product'),
                    current_values = [],
                    update_variant = null,
                    option_variant_id = $this.attr('data-variant-id');

                $values.removeClass('active');
                $this.filter('[data-js-option-value]').addClass('active');

                $section.removeAttr('data-disable-auto-select');

                // 解决页面资源未加在完成时，点击变体切换，然后再点加购物车，导致变体id不对的问题
                if(option_variant_id){
                    const updateData={update_variant:{id:option_variant_id},has_unselected_options: $product.find('[data-property][data-disable-auto-select]').length ? true : false}
                    _._updateFormVariantInput($product, updateData);
                    _._updateVariantsSelect($product, updateData);
                }

                _._loadJSON($product, json, function (json) {
                    var $active_values = $options.find('[data-js-option-value].active').add($options.find('option[data-value]:selected'));

                    $.each($active_values, function () {
                        var $this = $(this);

                        current_values.push($this.attr('data-value'));
                    });

                    $options.find('[data-js-option-value]').removeClass('active');

                    $.each(json.variants, function () {
                        if (current_values.join(' / ') === Shopify.handleizeArray(this.options).join(' / ')) {
                            if (!this.available && theme.product.hide_options_without_availability_variants) {
                                return false;
                            }

                            update_variant = this;

                            return false;
                        }
                    });

                    if (!update_variant && current_values.length > 1) {
                        $.each(json.variants, function () {
                            if (current_values[0] === Shopify.handleize(this.options[0]) && current_values[1] === Shopify.handleize(this.options[1])) {
                                if (!this.available) {
                                    if (update_variant || theme.product.hide_options_without_availability_variants) {
                                        return;
                                    }
                                }

                                update_variant = this;

                                if (this.available) {
                                    return false;
                                }
                            }
                        });
                    }

                    if (!update_variant) {
                        $.each(json.variants, function () {
                            if (current_values[0] === Shopify.handleize(this.options[0])) {
                                if (!this.available) {
                                    if (update_variant || theme.product.hide_options_without_availability_variants) {
                                        return;
                                    }
                                }

                                update_variant = this;

                                if (this.available) {
                                    return false;
                                }
                            }
                        });
                    }

                    if (!update_variant) {
                        update_variant = _._getDefaultVariant(json);
                    }

                    _._updatePossibleVariants($product, {
                        update_variant: update_variant,
                        json: json
                    });

                    $.each(update_variant.options, function (i, k) {
                        var $prop = $options.find('[data-property]').eq(i);

                        $prop.find('[data-js-option-value][data-value="' + Shopify.handleize(k) + '"]').addClass('active');
                        $prop.filter('[data-js-option-select]').val(Shopify.handleize(k)).trigger('change', [true]);
                    });

                    _._switchVariant($product, {
                        update_variant: update_variant,
                        json: json,
                        has_unselected_options: $product.find('[data-property][data-disable-auto-select]').length ? true : false
                    });
                    handlePaymentsOverTime();
                });
                
            };
            // 监听切换变体动作
            $body.on('click', this.selectors.options + ' [data-js-option-value]', onProcess);

            $body.on('mouseenter', this.selectors.options + '[data-js-options-onhover] [data-js-option-value]', theme.debounce(function (e) {
                onProcess(e, $(e.target));
            }, 400));

            $body.on('change', '[data-js-product] [data-js-option-select]', function (e, onupdate) {
                if (onupdate) {
                    return;
                }

                var $this = $(this).find('option[data-value]:selected');

                $(this).parents('.select').find('[data-js-select-dropdown]').removeAttr('data-dropdown-unselected');

                onProcess.call($this, e);
            });

            $body.on('change', '[data-js-product-variants="control"]', function () {
                var $this = $(this),
                    $product = $this.parents('[data-js-product], [data-js-product-clone]'),
                    dontUpdateVariantsSelect = true,
                    updateProductOptions = false;

                if ($product[0].hasAttribute('data-js-product-clone')) {
                    $product = $('[data-js-product-clone-id="' + $product[0].getAttribute('data-js-product-clone') + '"]');
                    dontUpdateVariantsSelect = false;
                    updateProductOptions = true;
                }

                var id = $this.find('option:selected').attr('value'),
                    json = $product.attr('data-json-product'),
                    update_variant = null;

                _._loadJSON($product, json, function (json) {
                    $.each(json.variants, function () {
                        if (+this.id === +id) {
                            update_variant = this;
                            return false;
                        }
                    });

                    _._switchVariant($product, {
                        update_variant: update_variant,
                        json: json,
                        dontUpdateVariantsSelect: dontUpdateVariantsSelect,
                        updateProductOptions: updateProductOptions
                    });
                });
            });

            theme.Global.responsiveHandler({
                namespace: '.product.load-json',
                element: $body,
                delegate: '[data-js-product][data-js-product-json-preload]',
                on_desktop: true,
                events: {
                    'mouseenter': function () {
                        var $this = $(this);

                        clearTimeout(timeout);

                        timeout = setTimeout(function () {
                            if (!$this.attr('data-json-product')) {
                                xhr = _._loadJSON($this, null, function () {
                                    xhr = null;
                                }, false);
                            }
                        }, 300);
                    },
                    'mouseleave': function () {
                        clearTimeout(timeout);

                        if (xhr) {
                            xhr.abort();
                            xhr = null;
                        }
                    }
                }
            });
        },
        _loadJSON: function ($product, json, callback, animate) {
            if ($product[0].hasAttribute('data-js-process-ajax-loading-json')) {
                $product.one('json-loaded', function () {
                    if (callback) {
                        callback(JSON.parse($product.attr('data-json-product')));
                    }
                });

                return;
            }

            animate = animate === undefined ? true : animate;

            if (json) {
                if (callback) {
                    callback(typeof json == 'object' ? json : JSON.parse(json));
                }
            } else {
                $product.attr('data-js-process-ajax-loading-json', true);

                /*if(animate) {
                    theme.Preloader.set($product);
                }*/

                var handle = $product.attr('data-product-handle');

                var xhr = $.ajax({
                    type: 'GET',
                    url: theme.routes.root_url + 'products/' + handle,
                    data: {
                        view: 'get_json'
                    },
                    cache: false,
                    dataType: 'html',
                    success: function (data) {
                        let json = {};
                        try {
                            const fixedJsonData = data.replace(/,\s*}/g, '}').replace(/,\s*]/g, ']');
                            json = JSON.parse(fixedJsonData);
                        } catch(err) {
                            console.error('变体json解析失败', err);
                            // __Xtool_Utils.exceptionNotification("product数据解析异常", JSON.stringify({err, data}));
                        }
                        $product.attr('data-json-product', JSON.stringify(json));

                        /*if(animate) {
                            theme.Preloader.unset($product);
                        }*/

                        if (callback) {
                            callback(json);
                        }

                        $product.trigger('json-loaded');
                    },
                    complete: function () {
                        $product.removeAttr('data-js-process-ajax-loading-json');
                    }
                });

                return xhr;
            }
        },
        switchByImage: function ($product, get_image, id, callback) {
            var _ = this,
                $image = $product.find('[data-js-product-image] img'),
                json = $product.attr('data-json-product'),
                data = false;

            this._loadJSON($product, json, function (json) {
                var json_images = json.images,
                    current_image_id = (get_image === 'by_id') ? +id : +$image.attr('data-image-id'),
                    image_index,
                    update_variant;

                $.each(json_images, function (i) {
                    if (+this.id === current_image_id) {
                        image_index = i;
                        return false;
                    }
                });

                if (image_index || image_index === 0) {
                    if (get_image === 'prev' && image_index !== 0) {
                        image_index--;
                    } else if (get_image === 'next' && image_index !== json_images.length - 1) {
                        image_index++;
                    }

                    $.each(json.variants, function () {
                        if (this.featured_image && +this.featured_image.id === +json_images[image_index].id) {
                            if (theme.product.hide_options_without_availability_variants && !this.available) {
                                return;
                            }

                            update_variant = this;
                            return false;
                        }
                    });

                    if (!update_variant) {
                        update_variant = _._getDefaultVariant(json);
                        update_variant.featured_image = json_images[image_index];
                    }

                    _._updateOptions($product, {
                        update_variant: update_variant,
                        json: json
                    });

                    _._switchVariant($product, {
                        update_variant: update_variant,
                        json: json,
                        has_unselected_options: $product.find('[data-property][data-disable-auto-select]').length ? true : false
                    });

                    data = {
                        index: image_index,
                        image: json_images[image_index],
                        is_first: image_index === 0,
                        is_last: image_index === json_images.length - 1
                    };
                }

                callback(data);
            });
        },
        _updatePossibleVariants: function ($product, data) {
            var $options = $product.find(this.selectors.options_attr),
                $section_eq_values,
                $section_eq_select_options,
                possible_variants = [],
                hidden_variants = [];

            if (data.update_variant.options.length > 1) {
                $.each(data.json.variants, function () {
                    if (Shopify.handleize(this.options[0]) !== Shopify.handleize(data.update_variant.options[0])) {
                        return;
                    } else if (!this.available) {
                        if (this.id !== data.update_variant.id && theme.product.hide_options_without_availability_variants) {
                            return;
                        } else {
                            hidden_variants.push(this);
                        }
                    }

                    possible_variants.push(this);
                });

                /*$.each(hidden_variants, function (i) {
                    const option = this.options[1];
    
                    $.each(possible_variants, function () {
                        if(option === this.options[1] && this.available) {
                            hidden_variants.splice(i, 1);
                        }
                    });
                });*/

                function recursiveException(i = 0) {
                    if (i >= hidden_variants.length) return;

                    $.each(possible_variants, function () {
                        if (hidden_variants[i].options[1] === this.options[1] && this.available) {
                            hidden_variants.splice(i, 1);
                            --i;
                            return false;
                        }
                    });
                    recursiveException(++i);
                }
                recursiveException();

                $section_eq_values = $options.find('[data-property]').eq(1).find('[data-js-option-value]');
                $section_eq_select_options = $options.find('[data-property]').eq(1).filter('[data-js-option-select]').parents('.select').find('[data-value]');

                $section_eq_values.addClass('disabled').removeClass('disabled-hidden');
                $section_eq_select_options.attr('disabled', 'disabled').removeAttr('data-disabled-hidden');

                $.each(possible_variants, function () {
                    $section_eq_values.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[1]) + '"]').removeClass('disabled');
                    $section_eq_select_options.filter('[data-value="' + Shopify.handleize(this.options[1]) + '"]').removeAttr('disabled');
                });

                $.each(hidden_variants, function () {
                    $section_eq_values.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[1]) + '"]').addClass('disabled-hidden');
                    $section_eq_select_options.filter('[data-value="' + Shopify.handleize(this.options[1]) + '"]').attr('data-disabled-hidden', 'disabled');
                });

                if (data.update_variant.options.length > 2) {
                    possible_variants = [];
                    hidden_variants = [];

                    $.each(data.json.variants, function () {
                        if (Shopify.handleize(this.options[0]) !== Shopify.handleize(data.update_variant.options[0]) || Shopify.handleize(this.options[1]) !== Shopify.handleize(data.update_variant.options[1])) {
                            return;
                        } else if (!this.available) {
                            if (this.id !== data.update_variant.id && theme.product.hide_options_without_availability_variants) {
                                return;
                            } else {
                                hidden_variants.push(this);
                            }
                        }

                        possible_variants.push(this);
                    });

                    $section_eq_values = $options.find('[data-property]').eq(2).find('[data-js-option-value]');
                    $section_eq_select_options = $options.find('[data-property]').eq(2).filter('[data-js-option-select]').parents('.select').find('[data-value]');

                    $section_eq_values.addClass('disabled').removeClass('disabled-hidden');
                    $section_eq_select_options.attr('disabled', 'disabled').removeAttr('data-disabled-hidden');

                    $.each(possible_variants, function () {
                        $section_eq_values.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[2]) + '"]').removeClass('disabled');
                        $section_eq_select_options.filter('[data-value="' + Shopify.handleize(this.options[2]) + '"]').removeAttr('disabled');
                    });

                    $.each(hidden_variants, function () {
                        $section_eq_values.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[2]) + '"]').addClass('disabled-hidden');
                        $section_eq_select_options.filter('[data-value="' + Shopify.handleize(this.options[2]) + '"]').attr('data-disabled-hidden', 'disabled');
                    });
                }
            }
        },
        _switchVariant: function ($product, data) {
                        data.update_variant.metafields = $.extend({}, data.json.metafields);

            $.each(data.json.variants_metafields, function () {
                if (+this.variant_id === +data.update_variant.id) {
                    data.update_variant.metafields = $.extend(true, data.update_variant.metafields, this.metafields);
                }
            });

            $.each(data.json.variants_quantity, function () {
                if (+this.id === +data.update_variant.id) {
                    // 变体库存小于等于0且开启了缺货后继续销售，则为pre order状态
                    if (+this.quantity <= 0 && this.policy == 'continue') {
                        data.update_variant.variant_pre_order = true;
                    }else{
                        data.update_variant.variant_pre_order = false;
                    }
                    // 变体库存小于等于0且关闭了缺货后继续销售，且开启了到货提醒，则为notify me状态
                    if (+this.quantity <= 0 && this.policy != 'continue' && data.json.metafields.replenish_notify_enabled) {
                        data.update_variant.variant_notify_me = true;
                    }else{
                        data.update_variant.variant_notify_me = false;
                    }

                    data.update_variant.inventory_quantity = this.quantity;

                    return false;
                }
            });

            //更新价格需要
            var clone_id = $product.attr('data-js-product-clone-id'),
                $clone_product = $('[data-js-product-clone="' + clone_id + '"]');

            window.__fbt_price = { price: 0, compare_at_price: 0 };
            this._updateContent($product, data);
            document.dispatchEvent(new CustomEvent('theme:product::switchVariant', {
                detail: {
                    $product: $product,
                    data: data,
                    $clone_product: $clone_product,
                    _updatePrice: this._updatePrice
                }
            }));
        },
        _getDefaultVariant: function (json) {
            var default_variant = {};

            $.each(json.variants, function () {
                if (+this.id === +json.default_variant_id) {
                    Object.assign(default_variant, this);
                    return false;
                }
            });

            return default_variant;
        },
        // 因切换变体，而导致页面所有可能发生变动的内容实体，都在这里集中更新处理
        _updateContent: function ($product, data) {
            var clone_id = $product.attr('data-js-product-clone-id'),
                $clone_product = $('[data-js-product-clone="' + clone_id + '"]');

            $product.attr('data-product-variant-id', data.update_variant.id);
            $product.add($clone_product).find('[data-js-product-options]').attr('data-variant-was-chanched', true);

            if (theme.StickySidebar) {
                theme.StickySidebar.update('listener-enable');
            }

            this._updateFormVariantInput($product, data);
            this._updatePrice($product, $clone_product, data);
            this._updateLabelSale($product, data);
            this._updateLabelInStock($product, data);
            this._updateLabelPreOrder($product, data);
            this._updateLabelOutStock($product, data);
            this._updateLabelHot($product, data);
            this._updateLabelNew($product, data);
            this._updateAddToCart($product, $clone_product, data);
            this._updateDynamicCheckout($product, data);
            this._updateSKU($product, data);
            this._updateBarcode($product, data);
            this._updateAvailability($product, data);
            this._updateGallery($product, data);
            this._updateLinks($product, data);
            this._updateHistory($product, data);
            this._updatePickupAvailable($product, data);
            this._updateAffirmPrice($product, data);
            this._updateFootBarDeliveryText($product, $clone_product, data);
            this._updatePackageVariantInfo($product, $clone_product, data);
            this._updateOptionsClass($product, $clone_product, data);
            this._updateOptionsLabel($product, data);
            theme.StoreLists.checkProductStatus($product);
            theme.ProductImagesNavigation.switch($product, data);

            if (!data.dontUpdateVariantsSelect) {
                this._updateVariantsSelect($product, data, true);
            }

            if (data.updateProductOptions) {
                this._updateOptions($product, data);
            }

            if ($clone_product.length) {
                this._updateVariantsSelect($clone_product, data);
                this._updateOptions($clone_product, data, $product);
                theme.ProductImagesNavigation.switch($clone_product, data);
            }

            if (theme.StickySidebar) {
                theme.StickySidebar.update('listener-process');
            }

            if (theme.StickySidebar) {
                theme.StickySidebar.update('listener-disable');
            }
        },
        _updateOptions: function ($product, data, $product_origin) {
            var _ = this;

            $product.each(function () {
                var $this = $(this),
                    $options = $this.find(_.selectors.options_attr),
                    $sections;

                if ($options.length) {
                    $options.find('[data-js-option-value]').removeClass('active');

                    _._updatePossibleVariants($this, data);

                    $.each(data.update_variant.options, function (i, k) {
                        var $prop = $options.find('[data-property]').eq(i);

                        $prop.find('[data-js-option-value][data-value="' + Shopify.handleize(k) + '"]').addClass('active');
                        $prop.filter('[data-js-option-select]').val(Shopify.handleize(k)).trigger('change', [true]);
                    });
                }

                if ($product_origin && theme.product.variant_auto_select !== 'enable') {
                    $sections = $product.find('[data-property]');

                    $sections.attr('data-disable-auto-select');

                    $product_origin.find('[data-property]').each(function (i, v) {
                        if (!this.hasAttribute('data-disable-auto-select')) {
                            $sections.eq(i).removeAttr('data-disable-auto-select');
                        }
                    });
                }
            });
        },
        _updateFormVariantInput: function ($product, data) {
            var $input = $product.find('[data-js-product-variant-input]');

            $input.attr('value', data.update_variant.id);
        },
        _updateVariantsSelect: function ($product, data, onchange) {
            var $select = $product.find('[data-js-product-variants]');

            if ($select.length && !data.has_unselected_options) {
                $select.val(data.update_variant.id);

                if (onchange) {
                    $select.change();
                }
            }
        },
        _updateAddToCart: function ($product, $clone_product, data) {
            // 这里更改切换变体时的按钮状态
            var $button = $product.add($clone_product).find('[data-js-product-button-add-to-cart]');

            if ($button.length && !data.has_unselected_options) {
                if (data.update_variant.variant_pre_order) {
                    $button.removeAttr('disabled').attr('data-button-status', 'pre-order');
                }else if (data.update_variant.variant_notify_me) {
                    $button.removeAttr('disabled').attr('data-button-status', 'notify-me');
                } else {
                    if (data.update_variant.available) {
                        const defaultStatus = $button.attr('data-button-default-status');

                        if (defaultStatus) {
                            $button.removeAttr('disabled').attr('data-button-status', defaultStatus);
                        } else {
                            $button.removeAttr('disabled data-button-status');
                        }
                    } else {
                        $button.attr('disabled', 'disabled').attr('data-button-status', 'sold-out');
                    }
                }
            }
        },
        _updateDynamicCheckout: function ($product, data) {
            var $button = $product.find('[data-js-product-button-dynamic-checkout]')
            var $button2 = $button.closest('.footerDynamicCheckoutBtn');

            if ($button.length && !data.has_unselected_options) {
                data.update_variant.available ? $button.removeClass('d-none') : $button.addClass('d-none');
                data.update_variant.available ? $button2.removeClass('d-none') : $button2.addClass('d-none');
            }
        },
        _updatePrice: function ($product, $clone_product, data, care, fbt) {
            try {
                var $price = $product.add($clone_product).find('[data-js-product-price]').parent(),
                    $discountTextContainer = $product.find('[data-js-product-price-sale-details]'),
                    $details = $product.find('[data-js-product-price-sale-details] span'),
                    $footbarDetails = $('.footbar-product-new').find('[data-js-product-price-sale-details]'),
                    currentDiscountText, currentDiscountValue;

                // 从 metafields 里获取减免金额
                let discountValue = null;
                if (data.json.metafields.action === "discount") {
                    try {
                        discountValue = data.json.metafields.discount_value;
                    } catch (err) {
                        discountValue = null;
                    }
                }
                
                if ($price.length) {
                    theme.ProductPrice.insertFull($product, $price, data.update_variant, discountValue, care, fbt);
                }

                $.each(data.json.variants_price_sale_details, function () {
                    if (+this.id === +data.update_variant.id) {
                        currentDiscountText = this.details;
                        currentDiscountValue = this.number;
                    }
                });
                let discountPrice = currentDiscountValue;
                if (discountValue) {
                    discountPrice = data.update_variant.compare_at_price - theme.ProductPrice.calcDiscountPrice(data.update_variant.price, discountValue);
                }
                // 计算FBT
                if (fbt) {
                    discountPrice = Number(discountPrice) + (fbt.compare_at_price - fbt.price);
                }

                if (care && care.compare_price) {
                    discountPrice = Number(discountPrice) + (care.compare_price * 100 - care.price * 100);
                }
                
                const oldMoney = Shopify.formatMoney(currentDiscountValue, theme.moneyFormat);
                const newMoney = Shopify.formatMoney(discountPrice, theme.moneyFormat);
                
                if (currentDiscountText) {
                    /* 替换为叠加折扣后的金额 */
                    const newDiscountHtml = currentDiscountText.replace(oldMoney, newMoney);
                    $discountTextContainer.html(`<span>${newDiscountHtml}</span>`).removeClass('d-none-important');
                    $footbarDetails.html(`<span>${newDiscountHtml}</span>`).removeClass('d-none-important');
                    if ($price.length || $details.length) {
                        if (theme.MultiCurrency) {
                            theme.MultiCurrency.update();
                        }
                    }
                } else {
                    $discountTextContainer.addClass('d-none-important');
                    $footbarDetails.addClass('d-none-important');
                }

            } catch (e) {
                console.error('变体切换价格出错', e);
                // __Xtool_Utils.exceptionNotification("变体切换价格出错", e);
            }
        },
        _updatePackageVariantInfo: function ($product, $clone_product, data) {   
            try {
                const variantOptions = data.json.options, variants = data.json.variants, variants_metafields = data.json.variants_metafields || [],
                    update_variant = data.update_variant, variants_quantity = data.json.variants_quantity, product_variant_package_label = data.json.product_variant_package_label;
                const variantOptionsHandleizeArray = Shopify.handleizeArray(variantOptions);
                const packageVariantConfigHandle = Shopify.handleize(product_variant_package_label);
                const packageOptionIndex = variantOptionsHandleizeArray.findIndex(v => packageVariantConfigHandle.indexOf(v) !== -1);
                const packageVariantDomProperty = variantOptionsHandleizeArray[packageOptionIndex];
                let currentShowedPackageVariantList = [];
                if (variantOptions.length === 1) {
                    currentShowedPackageVariantList = variants;
                } else {
                    currentShowedPackageVariantList = variants.filter(v => {
                        if (currentShowedPackageVariantList.length === 2) {
                            return packageOptionIndex === 0 ? v.option2 === update_variant.option2 : v.option1 === update_variant.option1;
                        }
                        if (packageOptionIndex === 0) {
                            return v.option2 === update_variant.option2 && v.option3 === update_variant.option3;
                        }
                        if (packageOptionIndex === 1) {
                            return v.option1 === update_variant.option1 && v.option3 === update_variant.option3;
                        }
                        if (packageOptionIndex === 2) {
                            return v.option1 === update_variant.option1 && v.option2 === update_variant.option2;
                        }
                    });
                }
                var $packageVariant = $product.find(`[data-property=${packageVariantDomProperty}]`);
                $packageVariant.find('[data-js-option-value]').each((i, currentVariantNode) => {
                    const $currentVariantNode = $(currentVariantNode);
                    const variantName = $currentVariantNode.attr('data-value');
                    const variantsMetafieldIds = variants_metafields.map(v => +v.variant_id);
                    const currentVariant = currentShowedPackageVariantList.find(v => Shopify.handleize(v.options[packageOptionIndex]) === variantName);
                    const oldProductVariantTopLabel = $currentVariantNode.find('.product-page__package-variant_top_label');
                    $currentVariantNode.find('.product-page-info__stock-countdown').addClass('d-none-important');
                    $currentVariantNode.find('.product-page__package_variant_dropdown_desc').addClass('d-none-important');
                    $currentVariantNode.find('.product-page__package_variant_dropdown_consists').addClass('d-none-important');
                    $currentVariantNode.find('.product-page__package_variant_dropdown_desc ul').addClass('d-none-important');
                    let showCurrentVariantDropDown = false;
                    if (oldProductVariantTopLabel) {
                        $(oldProductVariantTopLabel).remove();
                    }
                    if (currentVariant) {
                        const price = Shopify.formatMoneyMarket(currentVariant.price, theme.moneyFormat);
                        const compare_at_price = Shopify.formatMoneyMarket(currentVariant.compare_at_price, theme.moneyFormat);
                        $currentVariantNode.find('img').attr('src', currentVariant.featured_image && currentVariant.featured_image.src);
                        $currentVariantNode.find('.product-page__package-variant__price').html(price);
                        $currentVariantNode.find('.product-page__package-variant__price').attr('data-js-option-price', currentVariant.price);
                        $currentVariantNode.attr('data-variant-id', currentVariant.id);
                        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
                            $currentVariantNode.find('.product-page__package-variant__compare-price').html(compare_at_price).removeClass("d-none");
                        } else {
                          $currentVariantNode.find('.product-page__package-variant__compare-price').addClass("d-none").html('');
                        }
                        if (variantsMetafieldIds.includes(currentVariant.id)) {
                            const currentVariantsMetafields = variants_metafields.find(v => +v.variant_id === currentVariant.id);
                            const packageVariantTopLabelInfo = currentVariantsMetafields.metafields && currentVariantsMetafields.metafields.product && currentVariantsMetafields.metafields.product.package_variant_top_label;
                            const packageVariantContentTag = currentVariantsMetafields.metafields && currentVariantsMetafields.metafields.product && currentVariantsMetafields.metafields.product.package_content_tag;
                            const packageVariantDropDownInfo = currentVariantsMetafields.metafields && currentVariantsMetafields.metafields.product && currentVariantsMetafields.metafields.product.package_variant_dropdown_desc;
                            const packageVariantStockCountDown = currentVariantsMetafields.metafields && currentVariantsMetafields.metafields.variant_stock_countdown_config;

                            // 变体顶部标签
                            if (packageVariantTopLabelInfo) {
                                const topLabel = document.createElement('p');
                                const $topLabel = $(topLabel);
                                $topLabel.addClass('product-page__package-variant_top_label');
                                $topLabel.text(packageVariantTopLabelInfo.label);
                                $topLabel.css('color', packageVariantTopLabelInfo.color);
                                $topLabel.css('backgroundColor', packageVariantTopLabelInfo.backgroundColor);
                                $(currentVariantNode).find('.product-options__value--package').append($topLabel);
                            }
                            // 变体 freegift 标签
                            $currentVariantNode.find('.product-page__package-variant__free-gift').remove();
                            if (packageVariantContentTag) {
                                const $variantContent = $currentVariantNode.find('.product-page__package-variant__content');
                                $variantContent.append(`<p class="product-page__package-variant__free-gift" style="background-color:${packageVariantContentTag.backgroundColor}">${packageVariantContentTag.label}</p>`);
                            }

                            // 变体下拉框内容
                            if (packageVariantDropDownInfo) {
                                $currentVariantNode.find('.product-page__package-variant__title').text(packageVariantDropDownInfo.title);
                                if (packageVariantDropDownInfo.consists) {
                                    $currentVariantNode.find('.product-page__package_variant_dropdown_consists').html(packageVariantDropDownInfo.consists.replace(/\n/gi, '<br />'));
                                    $currentVariantNode.find('.product-page__package_variant_dropdown_consists').removeClass('d-none-important');
                                    showCurrentVariantDropDown = true;
                                }
                                let dropdownHtml = ``;
                                const explainList = packageVariantDropDownInfo.explainList;
                                if (explainList && explainList.length) {
                                    explainList.forEach((item) => {
                                        dropdownHtml += `<li>${item}</li>`
                                    })
                                    $currentVariantNode.find('.product-page__package_variant_dropdown_desc ul').removeClass('d-none-important');
                                    showCurrentVariantDropDown = true;
                                }
                                dropdownHtml += ``;
                                $currentVariantNode.find('.product-page__package_variant_dropdown_desc ul').html(dropdownHtml);
                            }

                            // 变体库存倒计时
                            if (packageVariantStockCountDown && packageVariantStockCountDown.enabled) {
                                const quantityInfo = variants_quantity.find(variantQualityInfo => +currentVariant.id === +variantQualityInfo.id);
                                const quantity = quantityInfo ? quantityInfo.quantity : 0;
                                const min_trigger_quantity = packageVariantStockCountDown.min_trigger_quantity;
                                if (quantity > 0 && quantity < min_trigger_quantity) {
                                    let $stock_countdown = $currentVariantNode.find('[data-js-product-stock-countdown]'),
                                        $title = $currentVariantNode.find('[data-js-product-stock-countdown-title]'),
                                        $progress = $stock_countdown.find('[data-js-product-stock-countdown-progress]');
                                    $currentVariantNode.find('.stock-countdown__counter').text(quantity);
                                    $progress.width(quantity / min_trigger_quantity * 100 + '%');
                                    $title.html(packageVariantStockCountDown.text_with_quantity.replace(
                                        '#quantity',
                                        '<span class="stock-countdown__counter">' + quantity + '</span>')
                                    );
                                    $currentVariantNode.find('.product-page-info__stock-countdown').removeClass('d-none-important');
                                    showCurrentVariantDropDown = true
                                }
                            }

                            // 显示变体下拉框，下拉框、库存倒计时时显示
                            if (showCurrentVariantDropDown) {
                                $currentVariantNode.find('.product-page__package_variant_dropdown_desc').removeClass('d-none-important');
                            }
                        
                        }
                    }
                });
            } catch (e) {
                // __Xtool_Utils.exceptionNotification("package变体切换报错", e);
                console.error('package变体切换报错', e);
            }
        },
        // 切换变体更换option的class
        _updateOptionsClass: function ($product, $clone_product, data) {
            var $options = $product.find(this.selectors.options_attr),
                $sections = $options.find('.product-options__section[data-style="text"],.product-options__section[data-style="large-text"]');
            $sections.map((index,item) => {
                var $notDisabledOptions = $(item).find("[data-js-option-value]:not('.disabled')");
                var notdisabledLen = $notDisabledOptions.length;
                if (notdisabledLen == 1) {
                    $notDisabledOptions.addClass('only-one');
                } else {
                    $notDisabledOptions.removeClass('only-one');
                }
            });
        },
        _updateFootBarDeliveryText: function ($product, $clone_product, data) {
            // 新的商品详情变体部分名称修改，同步修改label上的名字
            const $footbarDeleveyText = $('.footbar-product-new').find('[data-js-footbar-delevey-text]');
            const $firstAddToCartDescriptionDeleveyText = $('.first-add-to-cart-description').find('[data-js-footbar-delevey-text]');
            const productMetafieldsData = data.update_variant.metafields.product;
            if (productMetafieldsData && productMetafieldsData.delevey_tip) {
                const delevey_tip = productMetafieldsData.delevey_tip;
                $footbarDeleveyText.html(delevey_tip);
                $firstAddToCartDescriptionDeleveyText.html(delevey_tip);
            }else{
                $footbarDeleveyText.html($footbarDeleveyText.attr('data-default-deleveytip'));
                $firstAddToCartDescriptionDeleveyText.html($firstAddToCartDescriptionDeleveyText.attr('data-default-deleveytip'));
            }
        },

        _updateLabelSale: function ($product, data) {
            var $label = $product.find('[data-js-product-label-sale]');

            if ($label.length) {
                var html = '',
                    sale = (data.update_variant.compare_at_price && data.update_variant.compare_at_price > data.update_variant.price);

                $label[!sale ? 'addClass' : 'removeClass']('d-none-important');

                var percent = 0;
                if (sale) {
                    if (window.__fbt_price && window.__fbt_price.price !== 0 && window.__fbt_price.compare_at_price !== 0) {
                        const t_price = (data.update_variant.price + window.__fbt_price.price) * 100;
                        const c_price = (data.update_variant.compare_at_price + window.__fbt_price.compare_at_price);
                        percent = Math.ceil(100 - t_price  / c_price);
                    } else {
                        percent = Math.ceil(100 - data.update_variant.price * 100 / data.update_variant.compare_at_price);
                    }
                    //var percent = Math.ceil(100 - data.update_variant.price * 100 / data.update_variant.compare_at_price);

                    html += theme.strings.label.sale;
                    html = Shopify.addValueToString(html, {
                        'percent': percent
                    });
                }

                $label.html(html);
            }
        },
        _updateLabelInStock: function ($product, data) {
            var $label = $product.find('[data-js-product-label-in-stock]');

            if ($label.length) {
                $label[!data.update_variant.available || data.update_variant.variant_pre_order ? 'addClass' : 'removeClass']('d-none-important');
            }
        },
        _updateLabelPreOrder: function ($product, data) {
            var $label = $product.find('[data-js-product-label-pre-order]');

            if ($label.length) {
                $label[data.update_variant.variant_pre_order ? 'removeClass' : 'addClass']('d-none-important');
            }
        },
        _updateLabelOutStock: function ($product, data) {
            var $label = $product.find('[data-js-product-label-out-stock]');

            if ($label.length) {
                $label[data.update_variant.available ? 'addClass' : 'removeClass']('d-none-important');
            }
        },
        _updateLabelHot: function ($product, data) {
            var $label = $product.find('[data-js-product-label-hot]');

            if ($label.length) {
                $label[data.update_variant.metafields.labels && data.update_variant.metafields.labels.hot ? 'removeClass' : 'addClass']('d-none-important');
            }
        },
        _updateLabelNew: function ($product, data) {
            var $label = $product.find('[data-js-product-label-new]');

            if ($label.length) {
                $label[data.update_variant.metafields.labels && data.update_variant.metafields.labels.new ? 'removeClass' : 'addClass']('d-none-important');
            }
        },
        _updateSKU: function ($product, data) {
            var $sku = $product.find('[data-js-product-sku]');

            if ($sku.length) {
                $sku[data.update_variant.sku ? 'removeClass' : 'addClass']('d-none-important');

                $sku.find('span').html(data.update_variant.sku);
            }
        },
        _updateBarcode: function ($product, data) {
            var $barcode = $product.find('[data-js-product-barcode]');

            if ($barcode.length) {
                $barcode[data.update_variant.barcode ? 'removeClass' : 'addClass']('d-none-important');

                $barcode.find('span').html(data.update_variant.barcode);
            }
        },
        _updateAvailability: function ($product, data) {
            var $availability = $product.find('[data-js-product-availability]');

            if ($availability.length) {
                var html = '',
                    quantity = 0;

                $.each(data.json.variants_quantity, function () {
                    if (+this.id === +data.update_variant.id) {
                        quantity = +this.quantity;

                        return false;
                    }
                });

                if (data.update_variant.available) {
                    html += theme.strings.availability_value_in_stock;
                    html = Shopify.addValueToString(html, {
                        'count': quantity,
                        'item': quantity === 1 ? theme.strings.layout.cart.items_count.one : theme.strings.layout.cart.items_count.other
                    });
                } else {
                    html += theme.strings.availability_value_out_stock;
                }

                $availability.attr('data-availability', data.update_variant.available).find('span').html(html);
            }
        },

        _updateGallery: function ($product, data) {
            var image = data.update_variant.featured_media || data.json.media[0];
            document.dispatchEvent(new CustomEvent('on::product::gallery::update', {
                detail: {
                    id: image.id
                }
            }));
        },
        _updateLinks: function ($product, data) {
            var url = decodeURIComponent(window.location.origin) + '/products/' + data.json.handle + '?variant=' + data.update_variant.id;

            $product.find('a[href*="products/' + data.json.handle + '"]').attr('href', url);
        },
        _updateHistory: function ($product, data) {
            var $options = $product.find(this.selectors.options);

            if (!data.has_unselected_options && $options.length && $options[0].hasAttribute('data-js-change-history')) {
                var url = window.location.href.split('?')[0] + '?variant=' + data.update_variant.id;

                history.replaceState({ foo: 'product' }, url, url);
            }
        },
        _updatePickupAvailable: function ($product, data) {
            if (!theme.product.show_pickup_available) {
                return;
            }

            const handle = $product.attr('data-product-handle'),
                $pickupAvailable = $product.find('[data-js-pickup-available-container]');

            $pickupAvailable.addClass('is-loading');

            fetch(`${theme.routes.root_url}products/${handle}/?variant=${data.update_variant.id}&view=variant_data`)
                .then(response => response.text())
                .then(html => {
                    $pickupAvailable.html($(html).find('[data-js-pickup-available-container]').html()).removeClass('is-loading');
                })
                .catch(e => {
                    console.error(e);
                });
        },
        // 新增方法
        // TODO: skeleton 这个效果还没处理
        // TODO: 购物车还没加这个变动逻辑
        _updateAffirmPrice: function ($product, data) {
            var affirmEl = $(".affirm-as-low-as").attr('data-amount', data.update_variant.price);
            window.affirm && window.affirm.ui.ready(function () {
                window.affirm.ui.refresh();
                affirmEl.parent().removeClass('skeleton');
            });
        },
        // 更新耗材变体下面文案
        _updateOptionsLabel: function($product, data) {
            const $label = $product.find("[data-js-option-title-label]");
            const $labelActive = $product.find(".product-options__value--square.active");
            const txt = $labelActive?.attr('data-tippy-content');
            if($label && txt) {
                $label.text(txt);
            }
            
        }
    });

    theme.AssetsLoader.onPageLoaded(function () {
        theme.ProductOptions = new ProductOptions;
    });

    document.dispatchEvent(new CustomEvent('theme:js::loaded'))

  // 202504291929 临时添加
  function observeAffirm () {
    const observer = new MutationObserver((mutations, obs) => {
  if (window.affirm) {
    console.log(`affirm loaded`)
    window.affirm.ui.ready(function () {
                window.affirm.ui.refresh();
                affirmEl.parent().removeClass('skeleton');
            })
    obs.disconnect(); // 注销监听器
  }
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true
});
  }

  observeAffirm();
  

})(jQueryTheme);